import {
  Component,
  EventEmitter,
  Inject,
  Input,
  LOCALE_ID,
  Output,
} from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { AppService } from '../services/app.service';

@Component({
  selector: 'notification-dialog',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  templateUrl: './notification-dialog.component.html',
  styleUrl: './notification-dialog.component.scss',
})
export class NotificationDialogComponent {
  @Input() active: boolean = false;
  @Input() readNotifications: any = [];
  @Input() unreadNotifications: any = [];
  @Output() modalClosed = new EventEmitter<boolean>();
  @Output() markAllAsRead = new EventEmitter<boolean>();
  @Output() markAsRead = new EventEmitter<any>();
  @Output() markAsUnread = new EventEmitter<any>();

  activeTab: string = 'unread';

  constructor(
    private location: Location,
    private router: Router,
    private appService: AppService,
    @Inject(LOCALE_ID) public locale: string
  ) {}

  ngOnInit() {}

  markAllNotificationsRead() {
    this.markAllAsRead.emit();
  }

  markNotificationRead(notification: any) {
    this.markAsRead.emit(notification);
  }

  markNotificationUnread(notification: any) {
    this.markAsUnread.emit(notification);
  }

  notificationClick(notification: any) {
    if (notification.projectId) {
      this.router.navigate(['project-overview/' + notification.projectId]);
      // adding a redirect so if the user clicks multiple notifications and clicks on the back button,
      // it doesn't take the user to the previous project overview page from a previous notificiation,
      // but takes them to the main dashboard
      this.appService.setRedirectUrl(
        'project-overview/' + notification.projectId
      );
      this.closeDialog();
    } else if (notification.projectPhase) {
      // for legacy notification that have project phase set
      switch (notification.projectPhase) {
        case 'INVITATION': {
          if (notification.siteId) {
            this.router.navigate([`invitations/${notification.siteId}`]);
            this.closeDialog();
          } else {
            this.router.navigate(['invitations']);
          }
          break;
        }
        case 'PROPOSAL': {
          if (notification.siteId) {
            this.router.navigate([`proposals/${notification.siteId}`]);
            this.closeDialog();
          } else {
            this.router.navigate(['proposals']);
          }
          break;
        }
        case 'ACTIVE': {
          if (notification.siteId) {
            this.router.navigate([`active/${notification.siteId}`]);
            this.closeDialog();
          } else {
            this.router.navigate(['active']);
          }
          break;
        }
        default: {
          this.router.navigate(['invitations']);
          break;
        }
      }
    }
  }

  toggleTab(tab: string) {
    this.activeTab = tab;
    this.location.replaceState(
      this.location.path().split('?')[0],
      `tab=${tab}`
    );
  }

  closeDialog() {
    this.active = false;
    this.modalClosed.emit(this.active);
  }
}
